<div class="row">
    <div class="col-lg-12">
        <div class="card" id="contactList">
            <div class="card-header">
                <div class="d-flex align-items center">
                    <h5 class="card-title mb-0 flex-grow-1">{{'Change Password' | translate}} </h5>
                </div>
            </div>
            <div class="card-body">
                <form [formGroup]="changePasswordForm" (ngSubmit)="passwordChange()">
                    <div class="row g-2">
                        <div class="col-lg-7">
                            <div>
                                <label for="oldpasswordInput" class="form-label">{{'Old Password' |
                                    translate}}<span class="text-danger">*</span></label>
                                <div class="position-relative auth-pass-inputgroup mb-3">
                                    <input autocomplete="off" [type]="oldFieldTextType ? 'text' : 'password'"
                                        class="form-control" id="oldpasswordInput"
                                        placeholder="{{'Enter old password' | translate }}"
                                        formControlName="oldPassword"
                                        [ngClass]="{'is-invalid': changePasswordSubmitted && formForPassword['oldPassword'].errors}"
                                        autocomplete="off" />
                                    <button
                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                        type="button" (click)="toggleOldFieldTextType()">
                                        @if (!(changePasswordSubmitted && formForPassword['oldPassword'].errors)) {
                                        <i class="mdi align-middle"
                                            [ngClass]="{'mdi-eye-off-outline': !oldFieldTextType, 'mdi-eye-outline': oldFieldTextType}"></i>
                                        }
                                    </button>

                                    <div class="invalid-feedback"
                                        *ngIf="changePasswordSubmitted && formForPassword['oldPassword'].errors">
                                        <div *ngIf="formForPassword['oldPassword'].errors['required']">
                                            {{'Please enter the old password' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div>
                                <label for="newpasswordInput" class="form-label">{{'New Password' |
                                    translate}}<span class="text-danger">*</span></label>
                                <div class="position-relative auth-pass-inputgroup mb-3">
                                    <input autocomplete="off" [type]="newFieldTextType ? 'text' : 'password'"
                                        class="form-control" id="newpasswordInput"
                                        placeholder="{{'Enter password' | translate}}"
                                        formControlName="newPassword"
                                        [ngClass]="{'is-invalid': changePasswordSubmitted && formForPassword['newPassword'].errors}"
                                        autocomplete="off" />
                                    <button
                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                        type="button" (click)="toggleNewFieldTextType()">
                                        @if (!(changePasswordSubmitted && formForPassword['newPassword'].errors)) {
                                        <i class="mdi align-middle"
                                            [ngClass]="{'mdi-eye-off-outline': !newFieldTextType, 'mdi-eye-outline': newFieldTextType}"></i>
                                        }
                                    </button>

                                    <div class="invalid-feedback"
                                        *ngIf="changePasswordSubmitted && formForPassword['newPassword'].errors">
                                        <div *ngIf="formForPassword['newPassword'].errors['required']">
                                            {{'Please enter the new password' | translate}}</div>
                                        <div *ngIf="formForPassword['newPassword'].errors['minlength']">
                                            {{'Password must be at least 8 characters long' | translate}}</div>
                                        <div *ngIf="formForPassword['newPassword'].errors['pattern']">
                                            {{'Password must contain uppercase, lowercase, number, and special character' | translate}}r</div>
                                    </div>
                                    <small class="form-text text-muted" *ngIf="!changePasswordSubmitted"><em>
                                        {{'Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a special character' | translate}}</em>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div>
                                <label for="confirmpasswordInput" class="form-label">{{'Confirm Password' |
                                    translate}}<span class="text-danger">*</span></label>
                                <div class="position-relative auth-pass-inputgroup mb-3">
                                    <input autocomplete="off" [type]="confirmFieldTextType ? 'text' : 'password'"
                                        class="form-control" id="confirmpasswordInput"
                                        placeholder="{{'Re-enter Password' | translate}}"
                                        formControlName="confirmPassword"
                                        [ngClass]="{'is-invalid': changePasswordSubmitted && formForPassword['confirmPassword'].errors}"
                                        autocomplete="off" />
                                    <button
                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                        type="button" (click)="toggleConfirmFieldTextType()">
                                        @if (!(changePasswordSubmitted && formForPassword['confirmPassword'].errors)) {
                                        <i class="mdi align-middle"
                                            [ngClass]="{'mdi-eye-off-outline': !confirmFieldTextType, 'mdi-eye-outline': confirmFieldTextType}"></i>
                                        }
                                    </button>

                                    <div class="invalid-feedback"
                                        *ngIf="changePasswordSubmitted && formForPassword['confirmPassword'].errors">
                                        <div *ngIf="formForPassword['confirmPassword'].errors['required']">
                                            {{'Please Confirm Password' | translate}}
                                        </div>
                                        <div *ngIf="formForPassword['confirmPassword'].errors['mustMatch']">
                                            {{'Password did not match' | translate}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex auto-pwd mt-4">
                                <div class="input-group" *ngIf="isShowAutoPassword">
                                    <input type="text" [(ngModel)]="autoPassword" [ngModelOptions]="{standalone: true}"
                                        aria-label="Recipient's username" aria-describedby="button-addon2"
                                        class="form-control">
                                    <button type="button" id="button-addon2" class="btn btn-outline-success"
                                        (click)="onCopyPassword()"><i class="ri-file-copy-line"></i> {{'Copy' |
                                        translate}}</button>
                                </div>
                                <button type="button" class="btn btn-warning waves-effect waves-light"
                                    (click)="generatePassword();isShowAutoPassword=true"> {{'Generate' |
                                    translate}}</button>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="text-end">
                                <button *ngIf="!isUpdatePasswordButton" type="submit"
                                    class="btn btn-success">{{'Change Password'| translate}}</button>
                                <button *ngIf="isUpdatePasswordButton" type="button" class="btn btn-success btn-load">
                                    <span class="d-flex align-items-center">
                                        <span class="flex-grow-1 me-2">
                                            {{'Updating' | translate}}...
                                        </span>
                                        <span class="spinner-border flex-shrink-0" role="status">
                                            <span class="visually-hidden">{{'Updating' | translate}}...</span>
                                        </span>
                                    </span>
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>